// extracted by mini-css-extract-plugin
export var text = "styles-module--text--454Zj";
export var h1 = "styles-module--h1--h2yiP";
export var h2 = "styles-module--h2--klmWZ";
export var h3 = "styles-module--h3--9n7p5";
export var h4 = "styles-module--h4--8DbTM";
export var h5 = "styles-module--h5--1H2EM";
export var p1 = "styles-module--p1--lFQhd";
export var p2 = "styles-module--p2--awhje";
export var p3 = "styles-module--p3--50hzr";